import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import BusinessLandingFinal from "./pages/BusinessLandingFinal";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<BusinessLandingFinal />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
